import { processLogin } from '../actions/account';
import { object, string } from 'yup';

import { useFormik } from 'formik';

import Helmet from 'react-helmet';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Input from '../components/form/FormikInput.jsx';
import Alert from 'react-s-alert';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = async (values) => {
        try {
            await processLogin(values.email, values.password);
            let loc_state = location.state;
            let next = '/';

            if (loc_state && loc_state.nextPathname) {
                next = loc_state.nextPathname;
            }

            navigate(next);
        } catch (error) {
            console.error(error);
            if (error.response?.data) {
                setFieldError(error.response.data.error_field, error.response.data.message);
                document.getElementById(error.response.data.error_field)?.focus();
            } else {
                Alert.error('There was an error logging you in. Please try again later.');
            }
        }
    };

    const { values, errors, touched, isSubmitting, handleChange, handleSubmit, setFieldError } = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: object().shape({
            email: string().email().required(),
            password: string().required()
        }),
        onSubmit: handleClick
    });
    return (
        <div className="container">
            <Helmet title="Customer Login" />
            <div className="row">
                <section className="col-xs-12 col-md-6 col-md-offset-3">
                    <div className="login-section">
                        <div className="ls-content">
                            <form onSubmit={handleSubmit} noValidate>
                                <Input
                                    id="email"
                                    label="Email Address"
                                    type="text"
                                    value={values.email}
                                    error={errors.email}
                                    touched={touched.email}
                                    onChange={handleChange}
                                    required
                                />
                                <Input
                                    id="password"
                                    label="Password"
                                    type="password"
                                    value={values.password}
                                    error={errors.password}
                                    touched={touched.password}
                                    onChange={handleChange}
                                    required
                                />
                                <p>
                                    <button
                                        className="button button-primary full-xs auto-md"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        Log in
                                    </button>
                                </p>
                                <p>
                                    <Link to="/forgot-password">Forgot Your Password?</Link>
                                </p>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};
export default Login;
